import type { SVGProps } from 'react';

const SvgImageMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9 3H9.3C4.8 3 3 4.8 3 9.3V14.7C3 19.2 4.8 21 9.3 21H14.7C19.2 21 21 19.2 21 14.7V10.2'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4 19L8.33575 15.6674C9.03052 15.1338 10.0331 15.1942 10.6575 15.8083L10.9477 16.1003C11.6337 16.7749 12.7419 16.7749 13.4278 16.1003L17.0864 12.5059C17.7724 11.8314 18.8805 11.8314 19.5665 12.5059L21 13.9155'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M19 3L19 7' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path d='M21 5L17 5' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
  </svg>
);
export default SvgImageMd;
